export const TABS_WRAPPER_WIDTH = 100;
export const TAB_HEIGHT = 100;
export const ATOMIC_HEADER_HEIGHT = 70;
export const ANALYTICS_DASHBOARD_MARGIN = 20;
